export default __webpack_public_path__ + "static/produse-locale-615102d4a407a50bfe2be3139c7d0922.jpg";